import { useRouteError, isRouteErrorResponse } from "react-router-dom";

export default function RootErrorBoundary() {
  const error = useRouteError();

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof Error
      ? error.message
      : "请刷新页面或稍后重试。";

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-[#F5F5F7] px-6 py-16 text-center">
      <h1 className="text-lg font-semibold text-gray-900">页面出错了</h1>
      <p className="max-w-md text-sm text-gray-600">{message || "未知错误"}</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="rounded-xl bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition-colors hover:bg-indigo-700"
      >
        重试
      </button>
    </div>
  );
}
